var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScreenEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99984 2C1.26317 2 0.666504 2.59667 0.666504 3.33333V11.3333C0.666504 12.07 1.26317 12.6667 1.99984 12.6667H5.33317V13.3333C5.33317 13.7013 5.63184 14 5.99984 14H9.99984C10.3678 14 10.6665 13.7013 10.6665 13.3333V12.6667H13.9998C14.7365 12.6667 15.3332 12.07 15.3332 11.3333V3.33333C15.3332 2.59667 14.7365 2 13.9998 2H1.99984ZM2.6665 3.33333H13.3332C13.7012 3.33333 13.9998 3.632 13.9998 4V10.6667C13.9998 11.0347 13.7012 11.3333 13.3332 11.3333H2.6665C2.2985 11.3333 1.99984 11.0347 1.99984 10.6667V4C1.99984 3.632 2.2985 3.33333 2.6665 3.33333Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenEmpty);
export default __webpack_public_path__ + "static/media/ScreenEmpty.4dc6a11a8cface419d267967a00208d1.svg";
export { ForwardRef as ReactComponent };